<template>
  <div class="c-myroom-progress">
    <svg class="c-myroom-progress-svg" :width="width" :height="height">
      <circle transform="rotate(-90)" :r="radius" :cx="width/2" :cy="height/2" :stroke-dasharray="getStrokeDasharray"></circle>
      <circle transform="rotate(-90)" class="c-myroom-progress-svg-progress" :r="radius" :cx="width/2" :cy="height/2" :stroke-dasharray="getStrokeDasharray" :style="{strokeDashoffset: getStrokeDashoffset}"></circle>
      <path class="c-myroom-progress-svg-done" d="M0 0l8.365,7.9,15.337-14.407" :transform="`translate(${width/2 - 11.4}, ${height/2 - 1})`" :style="{stroke: done ? '#FF6565' : 'E9E9E9'}"/>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      default: 0
    },
    radius: {
      type: Number,
      default: 26
    },
    width: {
      type: Number,
      default: 58
    },
    height: {
      type: Number,
      default: 58
    },
    done: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
    }
  },
  computed: {
    getStrokeDashoffset () {
      return ((100 - this.progress) / 100) * Math.PI * (this.radius * 2)
    },
    getStrokeDasharray () {
      return Math.PI * (this.radius * 2)
    }
  }
}
</script>

<style lang="scss">
.c-myroom-progress{
  .c-myroom-progress-svg circle {
    stroke-dashoffset: 0;
    transition: stroke-dashoffset 1s linear;
    stroke: #E9E9E9;
    stroke-width: 5px;
    fill: transparent;
    transform-origin: 50% 50%;
    &.c-myroom-progress-svg-progress{
      stroke: #FF6565;
    }
  }
  .c-myroom-progress-svg-done {
    stroke: #E9E9E9;
    stroke-width: 6px;
    fill: transparent;
  }
}
</style>
